import { makeAutoObservable } from 'mobx'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { ZIndex } from 'shared/constants/zIndex'
import { uiStore } from 'shared/store/uiStore'
import { logger } from 'shared/lib'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { UKComplianceModalContent } from 'entities/Compliance/ui/UKComplianceModal/ui/UKComplianceModalContent'
import { UKComplianceModalActions } from 'entities/Compliance/ui/UKComplianceModal/ui/UKComplianceModalActions'
import { AdminComplianceApi } from 'entities/Admin/compliance'

const MODAL_ID = 'uk_compliance_get_approved'

export class UKComplianceModalStore {
  constructor(private _entities: IEntitiesStore) {
    makeAutoObservable(this)
  }

  private get _shownModal() {
    return this._entities.configStore.showUKComplianceModal
  }

  get isAdminOrOwner() {
    return Boolean(this._entities.usersStore.user?.isAdminOrOwnerRole)
  }

  private get _compliancePath() {
    return this._entities.complianceStore.internationalRegulatoryBundlesStore.pathToCurrentStep
  }

  onCloseModal = async () => {
    modalStore.closeModal(MODAL_ID)
    try {
      await AdminComplianceApi.updateUKComplianceModalShow()
    } catch (e) {
      logger.error(e)
    }
  }

  onGetApproved = () => {
    this.onCloseModal()
    uiStore.changeRoute({ path: this._compliancePath })
  }

  open = () => {
    if (!this._shownModal || !this._entities.usersStore.user?.isUKCountry) return

    modalStore.addModal({
      id: MODAL_ID,
      showCloseButton: false,
      disabledOverlayClose: true,
      disabledOnEscClose: true,
      zIndex: ZIndex.UI_300,
      type: ModalTypeList.DEFAULT,
      width: 480,
      showHeader: false,
      paddingContent: '32px 24px 16px',
      ModalActions: UKComplianceModalActions,
      ModalContent: UKComplianceModalContent,
      ModalContentProps: {
        store: this,
      },
    })
  }
}
